import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'

const component = universal(props => import('./PaymentCancelPage'))

class AsyncPaymentCancelPage extends AsyncPage {
  constructor() {
    super({
      isChromeless: true,
      pageComponent: component,
      basicDataRequirements: {
        instance: true,
        session: false,
      },
    })
  }
}

export default new AsyncPaymentCancelPage()
